import { forwardRef } from 'react';
import { ChartHR } from '@/entities/heart-rate';
import useBookmarkHrChart from './useBookmarkHrChart';

export type BookmarkHrChartHandle = {
  handleClickArrowButton: (isNext: boolean) => void;
};

export type BookmarkHrChartProps = {
  studyId: string;
  profileId: string;
  timezoneOffset: number;
  ecgDataMap: any;
};

/**
 * Renders the heart-rate chart shown under the ECG bookmark viewer on the rhythm events tab. Feeds the chart data and selected-strip updates from useBookmarkHrChart into ChartHR at a fixed minimum width, with the forwarded ref bridged to the chart handle.
 *
 * @param props - Chart inputs including the ECG data map, timezone offset and the study and profile ids.
 * @param ref - Forwarded handle the parent uses to drive the chart imperatively.
 * @returns The heart-rate chart bound to the rhythm events chart container.
 */
const BookmarkHrChart = forwardRef<BookmarkHrChartHandle, BookmarkHrChartProps>(
  ({ studyId, profileId, timezoneOffset, ecgDataMap }, ref) => {
    const { keyRecoil, dataChart, updatedSelectedStrip, chartHrRef } = useBookmarkHrChart(
      { studyId, profileId, timezoneOffset, ecgDataMap },
      ref,
    );

    return (
      <ChartHR
        ref={chartHrRef}
        idHtmlChart="rhythm-events-hr-chart-container"
        keyRecoil={keyRecoil}
        dataChart={dataChart}
        updatedSelectedStrip={updatedSelectedStrip}
        timezoneOffset={timezoneOffset}
        minWidth={1395}
      />
    );
  },
);

export default BookmarkHrChart;
